import { CityModel } from "types/models/CityModel";
import {
  BannerData,
  UserData,
  TransactionsData,
  PolygonData,
  LocationData,
  CentreData,
  RoleData,
  NetworkPartnerModel,
} from "../models/master/MasterApp";
import { AreaModel } from "types/models/AreaModel";

export const RESET_BANNER= "RESET_BANNER";
export const GET_BANNERS = "GET_BANNERS";
export const SET_BANNER_DATA = "SET_BANNER_DATA";

export const CREATE_BANNER = "CREATE_BANNER";
export const UPDATE_BANNER = "UPDATE_BANNER";
export const DELETE_BANNER = "DELETE_BANNER";


export const GET_USERS = "GET_USERS";
export const SET_USER_DATA = "SET_USER_DATA";
export const CREATE_USER = "CREATE_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";
export const RESET_USER = "RESET_USER";

export const GET_ROLES="GET_ROLES";

export const GET_CITIES="GET_CITIES";
export const SET_CITY_DATA="SET_CITY_DATA";

export const SET_AREAS_BY_CITY="SET_AREAS_BY_CITY";
export const GET_TRANSACTIONS = "GET_TRANSACTIONS";
export const SET_TRANSACTION_DATA = "SET_TRANSACTION_DATA";


export const CREATE_POLYGON = "CREATE_POLYGON";
export const GET_POLYGON = "GET_POLYGON";
export const SET_Polygon_DATA = "SET_Polygon_DATA";
export const RESET_POLYGON = "RESET_POLYGON";
export const UPDATE_POLYGON = "UPDATE_POLYGON";
export const DELETE_POLYGON = "DELETE_POLYGON";
export const GET_Location = "GET_Location";
export const SET_Location_DATA = "SET_Location_DATA";


export const GET_Centre = "GET_Centre";
export const SET_Centre_DATA = "SET_Centre_DATA";


export const SET_NETWORK_PARTNER_DATA = "SET_NETWORK_PARTNER_DATA";
export const GET_NETWORK_PARTNERS = 'GET_NETWORK_PARTNERS';
export const GET_COF_USERS = "GET_COF_USERS";

export interface ResetBanner{
  type: typeof RESET_BANNER;
}
export interface GetBannersAction {
  type: typeof GET_BANNERS;
  payload: { rows: BannerData[]; count: number };
}

export interface SetBannerDetailAction {
  type: typeof SET_BANNER_DATA;
  payload: BannerData;
}

export interface CreateBannerAction  {
  type: typeof CREATE_BANNER;
  payload: any; 
}

export interface UpdateBannerAction  {
  type: typeof UPDATE_BANNER;
  payload: any; 
}
export interface DeleteBanner{
  type: typeof DELETE_BANNER;
  payload: any;
}


export interface GetCityAction {
  type: typeof GET_CITIES
  payload: { rows: CityModel[]; count: number };
}

export interface SetCityAction {
  type: typeof SET_CITY_DATA;
  payload: CityModel;
}


export interface SetAreasByCityAction {
  type: typeof SET_AREAS_BY_CITY
  payload: { rows: AreaModel[]; count: number };
}

export interface GetUsersAction {
  type: typeof GET_USERS;
  payload: { users: UserData[]; userCount: number };
}

export interface SetUserDetailAction {
  type: typeof SET_USER_DATA;
  payload: UserData;
}


export interface CreateUserAction  {
  type: typeof CREATE_USER;
  payload: any; 
}

export interface UpdateUserAction  {
  type: typeof UPDATE_USER;
  payload: any; 
}
export interface DeleteUser{
  type: typeof DELETE_USER;
  payload: any;
}
export interface ResetUser{
  type: typeof RESET_USER;
}

export interface GetTransactionsAction {
  type: typeof GET_TRANSACTIONS;
  payload: { transactions: TransactionsData[]; transactionCount: number };
}

export interface SetTransactionDetailAction {
  type: typeof SET_TRANSACTION_DATA;
  payload: TransactionsData;
}
export interface ResetPolygon{
  type: typeof RESET_POLYGON;
}
export interface createPolygonAction{
  type: typeof CREATE_POLYGON;
  payload: any; 
}
export interface updatePolygonAction{
  type: typeof UPDATE_POLYGON;
  payload: any; 
}
export interface GetPolygonAction {
    type: typeof GET_POLYGON;
    payload: { rows: PolygonData[]; count: number };
}

export interface SetPolygonDetailAction {
  type: typeof SET_Polygon_DATA;
  payload: PolygonData[];
}

export interface DeletePolygon{
  type: typeof DELETE_POLYGON;
  payload: PolygonData;
}

export interface GetLocationAction {
  type: typeof GET_Location;
  payload: { location: LocationData[]; locationCount: number };
}

export interface SetLocationDetailAction {
  type: typeof SET_Location_DATA;
  payload: LocationData;
}


export interface GetCentreAction {
  type: typeof GET_Centre;
  payload: { centre: CentreData[]; centreCount: number };
}

export interface SetCentreDetailAction {
  type: typeof SET_Centre_DATA;
  payload: CentreData;
}

export interface GetRoleAction {
  type: typeof GET_ROLES;
  payload: RoleData[];
}

export interface SetNetworkPartnerAction {
  type: typeof SET_NETWORK_PARTNER_DATA;
  payload: NetworkPartnerModel;
}

export interface GetNetworkPartnerAction{
  type: typeof GET_NETWORK_PARTNERS;
  payload: NetworkPartnerModel[];
}
export interface GetCofUsersAction {
  type: typeof GET_COF_USERS;
  payload:UserData[];
}

export type MasterActionTypes =
  | ResetBanner
  | GetBannersAction
  | SetBannerDetailAction
  | CreateBannerAction
  | UpdateBannerAction
  | DeleteBanner
  | GetUsersAction
  | SetUserDetailAction
  | CreateUserAction
  | UpdateUserAction
  | DeleteUser
  | GetTransactionsAction
  | SetTransactionDetailAction
  | ResetPolygon
  | createPolygonAction
  | GetPolygonAction
  | SetPolygonDetailAction
  | GetLocationAction
  | SetLocationDetailAction
  | GetCentreAction
  | SetCentreDetailAction
  | ResetUser
  |GetCityAction
  |SetAreasByCityAction
  |SetCityAction
  |updatePolygonAction
  |DeletePolygon
  |GetRoleAction
  |SetNetworkPartnerAction
  |GetNetworkPartnerAction
  |GetCofUsersAction
